import { Schema as ProductsSchema } from "@comparaonline/products-schema";
import { Schema as QuoterSchema } from "@comparaonline/quoter-schema";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { useAppContext } from "../../../../../lib/appContext";
import { getFeatured, getProductImage } from "../../../../../models/product";
import { useFlagProps } from "../../../helpers/useFlagProps";
import { useMainAttribute } from "../../../helpers/useMainAttribute";

type ProductData = QuoterSchema.Product | ProductsSchema.ProductListProduct;

export const useResultsProps = () => {
  const formatMessage = useFormatMessage();
  const getMainAttribute = useMainAttribute();
  const getFlagProps = useFlagProps();
  const { businessUnitConfig } = useAppContext();
  const businessUnitName = businessUnitConfig.name;

  return (productData: ProductData) => ({
    featuredProps: getFeatured(productData),
    flagProps: getFlagProps(productData),
    id: productData.id,
    logoProps: getProductImage(productData, businessUnitName),
    mainAttribute: getMainAttribute(productData),
    productName: productData.name,
    viewDetailsProps: {
      text: formatMessage("results.viewDetails")
    }
  });
};
